<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="time">
                <el-input v-model="pgData.zbproname"  placeholder="项目名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="title">
                <el-input v-model="pgData.xmzbrname"  placeholder="招标人" clearable></el-input>
            </el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" @click="addHandler">添加项目</el-button>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="项目名称" prop="zbproname" min-width="130" fixed="left"></el-table-column>
            <el-table-column label="项目编号" prop="zbprocode" min-width="130" fixed="left"></el-table-column>
            <el-table-column label="项目经理" prop="prousername" min-width="50"></el-table-column>
            <el-table-column label="招标人" prop="xmzbrname" min-width="110"></el-table-column>
            <el-table-column label="交易中心" min-width="110">
                <template slot-scope="scope">
                    <jyzx-state 
                        v-if="scope.row.processflag === '1'"
                        :data="scope.row">
                    </jyzx-state>
                    
                    <template v-else>
                        <my-tag 
                        type="success" 
                        v-if="scope.row.shbj==='1'&&scope.row.ext2==='1'&&scope.row.xtts==='1'">
                            {{scope.row.ext1}}--已推送
                        </my-tag>
                        <my-tag
                        type="warning" 
                        v-if="scope.row.shbj==='1'&&scope.row.ext2==='1'&&scope.row.xtts!=='1'">
                            {{scope.row.ext1}}--待推送
                        </my-tag>
                        <my-tag
                        v-if="scope.row.shbj==='1'&&scope.row.ext2!=='1'">
                            {{scope.row.ext1}}--无需推送
                        </my-tag>
                        <my-tag
                        type="warning" 
                        v-if="scope.row.shbj!=='1'">
                            {{scope.row.ext1}}--待提交
                        </my-tag>
                    </template>
                    <push-type 
                        :column="scope.row" 
                        :pushPage="'zbxm'" 
                        :primaryKey="scope.row.zbprocode"
                        :procode="scope.row.by1">
                    </push-type>
                </template>
            </el-table-column>
            
            <el-table-column label="操作" min-width="130" fixed="right">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        style="float:left"
                        @reload="reloadHandler"
                        @detail="detailClick(scope.row)"
                        :config="BTN_CONF_ZFCG">
                    </btn-list>
                    <btn-elec-agree :listType="listTypeVal" :izShow="!(scope.row.ext3==='2'&&scope.row.ext3childtype==='1')" :row="scope.row"></btn-elec-agree>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/revision/Zbdl/GovPurchase/queryListData.json`">
        </my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

import BTN_CONF_ZFCG from '../config/btn-list-zfcg'
import JyzxState from '@views/bidding/components/jyzx-state'
import BtnElecAgree from '@views/bidding/elec-agreement/components/btn'

import PushType from '@/components-sys/push-type'

export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {BtnElecAgree,PushType,JyzxState},
    data() {
        return{
            pgData: {
                type:this.getQuery('type'),
                childtype:this.getQuery('childtype'),
                ext3childtype: this.getQuery('ext3childtype'),
                zbproname:'',
                xmzbrname: '',
                sortname:'zbprocode'
            },

            BTN_CONF_ZFCG,
            listTypeVal:'zfcg',
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        detailClick(row){
            this.goto({
                path: '/bidding/project/zfcg/detail',
                query: {
                    id: row.zbprocode,
                    type: this.getQuery('type'),
                    ext3childtype: this.getQuery('ext3childtype'),
                    childtype: '',
                }
            });
        },
        
    },
    created() {
        setSession('isRevision',0)
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
